/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// page
import Page from 'material/structure/page/page';
// group
import Group from 'material/group/group';
// structure
import Content from 'material/structure/content/content';
// copy
import Title from 'material/copy/title/title';
import BodyCopy from 'material/copy/bodycopy/bodycopy';
// ctas
import Link from 'material/ctas/link/link_container';
// graphics
import Logo from 'material/graphic/logo/logo';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/error/error_template/error_template_styles';



/* ========== ~~~~~~~~~~ ERROR : TEMPALTE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const ErrorTemplate = (props) => {
    return(
        <Page name={`errortemplate`} klass={props.classes.errortemplate}>
            <Content>
                <Group name={`message`}>
                    <Link type={`internal`} name={`insticator`} action={`dashboard/home`} title={`Return to Home Page`}>
                        <Logo name={`insticator`} text={`Insticator`} />
                    </Link>
                    <div className={`code`}>{props.code}</div>
                    <Title>
                        {props.title}
                    </Title>
                    <BodyCopy>
                        {props.bodycopy}
                    </BodyCopy>
                    {props.button}
                </Group>
                <Group name={`visual`}>
                    {props.illustration}
                </Group>
            </Content>
        </Page>
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(ErrorTemplate);
